/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_ProviderInputs */

const en_admin_subscriptions_provider = /** @type {(inputs: Admin_Subscriptions_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

const zh_admin_subscriptions_provider = /** @type {(inputs: Admin_Subscriptions_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付方式`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Admin_Subscriptions_ProviderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_provider = /** @type {((inputs?: Admin_Subscriptions_ProviderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_ProviderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_provider(inputs)
	return zh_admin_subscriptions_provider(inputs)
});
export { admin_subscriptions_provider as "admin.subscriptions.provider" }